export const liveDistricts = ['Thanjavur', 'Coimbatore']

export const openingNextDistricts = ['Kancheepuram', 'Madurai', 'Nilgiris']

export const liveDistrictsLabel = liveDistricts.join(' and ')
